// Expense and result keys - labels are now managed through i18n
// The 'key' field is used for both data storage and as the i18n translation key
export const expenseKeys = [
  { key: "salesReturns" },
  { key: "grants" },
  { key: "productionExpenses" },
  { key: "shippingAndCustoms" },
  { key: "spoilage" },
  { key: "supportAndMaintenance" },
  { key: "productionMachinery" },
  { key: "digitalMarketingExpenses" },
  { key: "printedAds" },
  { key: "outdoorAds" },
  { key: "radioTvAds" },
  { key: "salesStaffExpenses" },
  { key: "commissions" },
  { key: "domesticTravelExpenses" },
  { key: "internationalTravelExpenses" },
  { key: "promotionEventExpenses" },
  { key: "shippingDeliveryExpenses" },
  { key: "salesStaffAssets" },
  { key: "rdPersonnelExpenses" },
  { key: "consultancyExpenses" },
  { key: "testPrototypeExpenses" },
  { key: "materialExpenses" },
  { key: "rdSoftwareHardwareExpenses" },
  { key: "patentLicenseExpenses" },
  { key: "universityCollaborationExpenses" },
  { key: "rdFacilityExpenses" },
  { key: "rdIncentiveExpenses" },
  { key: "outsourcingExpenses" },
  { key: "rdTravelExpenses" },
  { key: "rdEquipmentExpenses" },
  { key: "managementSalaries" },
  { key: "hrAccountingExpenses" },
  { key: "legalConsultancyExpenses" },
  { key: "officeEquipmentExpenses" },
  { key: "generalOfficeExpenses" },
  { key: "rentExpenses" },
  { key: "communicationExpenses" },
  { key: "trainingExpenses" },
  { key: "managementTravelExpenses" },
  { key: "softwareLicenses" },
  { key: "representationExpenses" },
  { key: "insuranceExpenses" },
  { key: "consultingExpenses" },
  { key: "membershipExpenses" },
  { key: "creditInterests" },
  { key: "bankCommissions" },
  { key: "leasingExpenses" },
  { key: "maturityDifferences" },
  { key: "depreciationExpense" },
  { key: "taxAmount" },
  { key: "depreciationExpenses" }
];


export const resultKeys = [
  { key: "totalRevenue" },
  { key: "costOfSales" },
  { key: "totalMarketingSalesExpenses" },
  { key: "totalRDExpenses" },
  { key: "totalGeneralAdminExpenses" },
  { key: "totalFinancingExpenses" },
  { key: "grossProfit" },
  { key: "totalDepreciation" },
  { key: "taxAmount" },
  { key: "ebit" },
  { key: "percentageEbit" },
  { key: "ebitda" },
  { key: "percentageEbitda" }
];